import { render, staticRenderFns } from "./MailService.vue?vue&type=template&id=35e85fff&scoped=true&"
import script from "./MailService.vue?vue&type=script&lang=js&"
export * from "./MailService.vue?vue&type=script&lang=js&"
import style0 from "./MailService.vue?vue&type=style&index=0&id=35e85fff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e85fff",
  null
  
)

export default component.exports